module.exports = __webpack_public_path__ + "static/img/qd16.2a80e5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/qualificationDoc/qd16.jpg
// module id = tcFC
// module chunks = 1